<video *ngIf="mostrarVideo" muted autoplay style="width: 100%; height: 100%; object-fit: cover; position:fixed; z-index: 9000;">
  <source src="../assets/SaveInsta.App - 3145372830953141225.mp4" type="video/mp4">
</video>
<div class="contenedor-flex" >
  <div class="parte-izquierda" style="margin-right: 5%;">
    <app-title message="EN PREPARACIÒN"></app-title>
    <div class="column">
      <app-number-card *ngFor="let item of enPreparacion" class="app-number-card" number="{{item.selfServiceConfiguration.numeroOrden}}" [name]="item.selfServiceConfiguration.nombreCliente"></app-number-card>
    </div>

  </div>
  <div class="parte-derecha">
    <app-title message="RETIRAR" backgroundColor="#5CD061"></app-title>
    <div class="column">
      <app-number-card *ngFor="let item of Preparado" class="app-number-card" number="{{item.selfServiceConfiguration.numeroOrden}}" [name]="item.selfServiceConfiguration.nombreCliente"></app-number-card>
    </div>
  </div>

</div>

